import React from 'react';
import { Box, BoxProps } from 'rebass';

type ModalBodyProps = BoxProps & {
  children: React.ReactNode;
};

const ModalBody = (props: ModalBodyProps): JSX.Element => (
  <Box
    px={2}
    py={2}
    {...(props as any)}
    sx={{
      flexShrink: 1,
      flexGrow: 1,
      overflowY: 'auto',
    }}
  >
    {props.children}
  </Box>
);

export default ModalBody;
